// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whats-new {
  background-image: url(https://res.cloudinary.com/lojaali/image/upload/q_auto/v1/SWETROCAMUST22/campaign/snowfall.png);
  background-position: center;
  background-repeat: no-repeat;
}
.whats-new h1 {
  font-size: 3.2rem;
}
.whats-new h2 {
  font-size: 2.2rem;
  text-transform: uppercase;
}

@media (max-width: 767px) {
  .whats-new {
    background-image: url(https://res.cloudinary.com/lojaali/image/upload/q_auto/v1/SWETROCAMUST22/campaign/snowfall_mobile.png);
    background-size: cover;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/campaign/what-is-new/what-is-new.component.scss"],"names":[],"mappings":"AAGA;EACI,qHAAA;EACA,2BAAA;EAEA,4BAAA;AAHJ;AAKI;EACI,iBAAA;AAHR;AAMI;EACI,iBAAA;EACA,yBAAA;AAJR;;AAWA;EACI;IACI,4HAAA;IACA,sBAAA;EARN;AACF","sourcesContent":["@use '../../../../assets/styles/colors' as colors;\n@use '../../../../assets/styles/bootstrap-essentials';\n\n.whats-new {\n    background-image: url(https://res.cloudinary.com/lojaali/image/upload/q_auto/v1/SWETROCAMUST22/campaign/snowfall.png);\n    background-position: center;\n    //background-size: cover;\n    background-repeat: no-repeat;\n\n    h1 {\n        font-size: 3.2rem;\n    }\n\n    h2 {\n        font-size: 2.2rem;\n        text-transform: uppercase;\n    }\n}\n\n\n\n\n@media (max-width: 767px) {\n    .whats-new {\n        background-image: url(https://res.cloudinary.com/lojaali/image/upload/q_auto/v1/SWETROCAMUST22/campaign/snowfall_mobile.png);\n        background-size: cover;\n    }\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
